import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { InspectionEquipment } from '../../../class/inspection-equipment';
import { InspectionEquipmentService } from '../../../service/inspection-equipment/inspection-equipment.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';

@Component({
  selector: 'app-new-inspection-equipment',
  templateUrl: './new-inspection-equipment.component.html',
  styleUrls: ['./new-inspection-equipment.component.scss']
})
export class NewInspectionEquipmentComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: InspectionEquipment;
    public promiseForm: Promise<any>;
    public form: FormGroup;
    public name: AbstractControl;
    public group: AbstractControl;
    public expectation: AbstractControl;
    public stealable: AbstractControl;
    public damageable: AbstractControl;
    public optionsSelectionGroup: any[];
    public save_exit: boolean;

    constructor(
        fb: FormBuilder,
        public inspectionEquipment: InspectionEquipmentService,
        public translate: TranslateService,
        private notificationsService: NotificationsService,
        private ngZone: NgZone) {

        this.optionsSelectionGroup = [];
          this.optionsSelectionGroup.push({label: '1. DATOS ESTACIÓN', value: '1. DATOS ESTACIÓN'});
          this.optionsSelectionGroup.push({label: '2. PLANTA(S) ELÉCTRICA(S)', value: '2. PLANTA(S) ELÉCTRICA(S)'});
          this.optionsSelectionGroup.push({label: '3. AIRE(S) ACONDICIONADO(S)', value: '3. AIRE(S) ACONDICIONADO(S)'});
          this.optionsSelectionGroup.push({label: '4. OTROS', value: '4. OTROS'});
          this.optionsSelectionGroup.push({label: '5. POWER(S)', value: '5. POWER(S)'});

        this.save_exit = false;

        this.form = fb.group({
            'name': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
            'group': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
            'expectation': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
            'stealable': [''],
            'damageable': [''],
        });
        this.name = this.form.controls['name'];
        this.group = this.form.controls['group'];
        this.expectation = this.form.controls['expectation'];
        this.stealable = this.form.controls['stealable'];
        this.damageable = this.form.controls['damageable'];
    }

    ngOnInit() {
        if (this.edit) {
          this.name.setValue(this.edit.name);
          this.group.setValue(this.edit.group);
          this.expectation.setValue(this.edit.expectation);
          this.stealable.setValue(this.edit.stealable);
          this.damageable.setValue(this.edit.damageable);
        }
    }

    public cancelInspectionEquipment () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newInspectionEquipment(values);
    }

    public newInspectionEquipment(values: InspectionEquipment) {
        const param = {
            'name': values.name,
            'expectation': values.expectation,
            'group': values.group,
            'stealable' :values.stealable,
            'damageable' : values.damageable,
          };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.inspectionEquipment.updateInspectionEquipment(this.edit.id, param)
                :
                this.inspectionEquipment.newInspectionEquipment(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        }
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/inspection-equipments/new-inspection-equipment/new-inspection-equipment.component.ts